// @flow

// Links to best of category posts
export const VideoCallAppsLink = {
  text: 'Video Call Software',
  href: '/blog/best-video-conferencing-apps/',
};

export const EmailAppsLink = {
  text: 'Email Apps',
  href: '/blog/best-email-app/',
};

export const CRMAppsLink = {
  text: 'CRM Software',
  href: '/learn/crm/best-crm-app/',
};

export const NoteAppsLink = {
  text: 'Note Apps',
  href: '/blog/best-note-taking-apps/',
};

export const CalendarAppsLink = {
  text: 'Calendar Apps',
  href: '/blog/best-calendar-apps/',
};

export const ProjectManagementAppsLink = {
  text: 'Project Management Software',
  href: '/learn/project-management/best-project-management-software/',
};

// Links to app pages on Zapier

export const SlackLink = {
  text: 'Slack',
  href: '/apps/slack/integrations',
};

export const SalesforceLink = {
  text: 'Salesforce',
  href: '/apps/salesforce/integrations',
};

export const HubSpotLink = {
  text: 'HubSpot CRM',
  href: '/apps/hubspot-crm/integrations',
};

export const PayPalLink = {
  text: 'PayPal',
  href: '/apps/paypal/integrations',
};

export const AsanaLink = {
  text: 'Asana',
  href: '/apps/asana/integrations',
};

export const StripeLink = {
  text: 'Stripe',
  href: '/apps/stripe/integrations',
};

export const IntercomLink = {
  text: 'Intercom',
  href: '/apps/intercom/integrations',
};

export const GitLabLink = {
  text: 'GitLab',
  href: '/apps/gitlab/integrations',
};

export const MagentoLink = {
  text: 'Magento 2.X',
  href: '/apps/magento-v2/integrations',
};

export const NetSuiteLink = {
  text: 'NetSuite',
  href: '/apps/netsuite/integrations',
};

export const WooComerceLink = {
  text: 'WooCommerce',
  href: '/apps/woocommerce/integrations',
};

export const BaseCampLink = {
  text: 'Basecamp 3',
  href: '/apps/basecamp3/integrations',
};

// Links to blog posts

export const HowToUseEvernoteLink = {
  image:
    'https://images.zapier.com/storage/blog/956a19a106e3fa80c9320256833d88b7_2.250x250.png',
  text: 'Remember Everything with Evernote: 30+ of the Best Tips and Tricks',
  href: '/blog/how-to-use-evernote/',
};

export const ManageInboxLink = {
  image:
    'https://images.zapier.com/storage/blog/22f3fef0ede04bde24907cd739f33a62.250x250.png',
  text:
    'Forget Inbox Zero: Manage Your Inbox Better with These Smart Email Workflows',
  href: '/blog/email-inbox-workflow/',
};

export const BoostMotivationLink = {
  image:
    'https://images.zapier.com/storage/blog/871b3a6c3073405934d5221e7af39f82.250x250.png',
  text:
    "3 Science-Backed Ways to Boost Your Motivation (Even When You Don't Feel Like Working)",
  href: '/blog/stay-motivated-at-work/',
};

// Apps Link with submenu

const appsLink = {
  href: '/apps',
  icon: 'navApps',
  text: 'Apps',
  submenu: [
    {
      title: 'Best Of',
      links: [
        VideoCallAppsLink,
        EmailAppsLink,
        CRMAppsLink,
        NoteAppsLink,
        CalendarAppsLink,
        ProjectManagementAppsLink,
      ],
    },
    {
      title: 'Explore',
      links: [
        SlackLink,
        SalesforceLink,
        HubSpotLink,
        PayPalLink,
        AsanaLink,
        StripeLink,
        IntercomLink,
        GitLabLink,
        MagentoLink,
        NetSuiteLink,
        WooComerceLink,
        BaseCampLink,
      ],
    },
    {
      title: 'Tips & Advice',
      links: [HowToUseEvernoteLink, ManageInboxLink, BoostMotivationLink],
    },
  ],
};

export default appsLink;
